import styled from "styled-components";

export const KPIcard = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: ${({ borderRadius }) => borderRadius || "10px"};
  border: ${({ border }) => border || "1px solid #cccccc"};
`;
export const IconKpi = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  background: "none";
  svg {
    width: ${({ svgWidth }) => svgWidth || "50px"};
    height: ${({ svgHeight }) => svgHeight || "50px"};
    path,
    line,
    circle,
    polygon {
      color: $white;
    }
  }
`;

export const ContentKpi = styled.div`
  font-family: "Nunito";
  padding: 5px 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  h3 {
    font-size: 12px;
    margin-bottom: 0;
  }
  h4 {
    font-size: 14px;
    margin-bottom: 0;
  }
  p {
    margin-bottom: 0;
    font-size: 16px;
    color: #293134;
    font-weight: 700;
  }
`;
